import { create } from 'zustand';

import { IPoll } from '@src/types';

interface IPollStore {
  polls: IPoll[];
  hasUnvisitedPolls: boolean;
  singleVotesCounter: Map<string, number>;
  setPolls: (polls: IPoll[]) => void;
  appendPoll: (poll: IPoll) => void;
  setSingleVotesCounter: (votes: Map<string, number>) => void;
  setHasUnvisitedPolls: (hasUnvisitedPolls: boolean) => void;
  updatePoll: (pollId: string, data: Partial<IPoll>) => void;
  updatePollVote: (pollId: string, vote: string[]) => void;
  resetStates: () => void;
}

const defaultValues = {
  polls: [],
  hasUnvisitedPolls: false,
  singleVotesCounter: new Map(),
};

export const usePollsStore = create<IPollStore>((set) => ({
  ...defaultValues,
  setPolls: (polls) =>
    set(() => ({
      polls,
    })),
  appendPoll: (poll) =>
    set((state) => {
      const clonedPolls = structuredClone(state.polls);
      clonedPolls.push(poll);
      return {
        polls: clonedPolls,
      };
    }),
  setSingleVotesCounter: (singleVotesCounter) => set((state) => ({ ...state, singleVotesCounter })),
  setHasUnvisitedPolls: (hasUnvisitedPolls) =>
    set(() => ({
      hasUnvisitedPolls,
    })),

  updatePoll: (pollId, data) =>
    set((state) => {
      const clonedPolls = structuredClone(state.polls);
      const pollIndex = state.polls.findIndex(({ id }) => id === pollId);
      if (pollIndex > -1) {
        clonedPolls[pollIndex] = { ...clonedPolls[pollIndex], ...data };
      }
      return {
        ...state,
        polls: clonedPolls,
      };
    }),
  updatePollVote: (pollId, vote) =>
    set((state) => {
      const clonedPolls = structuredClone(state.polls);
      const pollIndex = state.polls.findIndex(({ id }) => id === pollId);
      if (pollIndex > -1) {
        clonedPolls[pollIndex].myVote = vote;
      }
      return {
        ...state,
        polls: clonedPolls,
      };
    }),
  // Reset all states to default values
  resetStates: () =>
    set(() => ({
      ...defaultValues,
    })),
}));
